import React from "react"
import {
  LineChart, Line, CartesianGrid, ResponsiveContainer, XAxis, YAxis, Label
} from "recharts"

function WellbeingIndexChart({ results, xAxisLabel, yAxisLabel }) {
  const datas = [...results.map(r => ({ name: r.completed_at_month, value: r.wellbeing_index }))].reverse()
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 770

  // mobile-specific adjustments
  let leftMargin = 0
  let yTickMargin = 20
  let yLabelOffset = -10
  if (yAxisLabel) {
    leftMargin = isMobile ? 14 : 44
    yTickMargin = isMobile ? 4 : 20
    yLabelOffset = isMobile ? -6 : -10
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={500}
        height={300}
        data={datas}
        // recharts 3 turns this on by default; without a <Tooltip> it only adds a
        // tab stop announced as role="application". Keep the recharts 2 behaviour.
        accessibilityLayer={false}
        margin={{
          top: 32,
          right: 5,
          bottom: xAxisLabel ? 16 : 5,
          left: leftMargin
        }}>
        <Line type="monotone" dataKey="value" stroke="#2A317D" strokeWidth={2} dot={{ stroke: "#2A317D", strokeWidth: 8 }} />
        <CartesianGrid stroke="#DCDDDE" />
        <XAxis dataKey="name" axisLine={false} tickLine={false} padding={{ left: 30, right: 30 }} tickMargin={20} height={xAxisLabel ? 64 : 40}>
          {xAxisLabel && <Label fill="#6B7280" value={xAxisLabel} position="insideBottom" offset={0} style={{ fontSize: 14 }} />}
        </XAxis>
        <YAxis domain={[0, 100]} axisLine={false} tickLine={false} tickMargin={yTickMargin}>
          {yAxisLabel && <Label fill="#6B7280" value={yAxisLabel} angle={-90} position="insideLeft" offset={yLabelOffset} style={{ textAnchor: "middle", fontSize: 14 }} />}
        </YAxis>
      </LineChart>
    </ResponsiveContainer>
  )
}

export default WellbeingIndexChart
